export default "__VITE_ASSET__j9rURBad__"